import Header from './components/Header';
import { AuthProvider, useAuth } from "./AuthContext";
// import ProductScan from './components/ProductScan';
import React, { useState, useEffect, useRef} from "react";
import { Navigate } from "react-router-dom";
import { configData } from "./config";
import { BrowserRouter as Router, Routes, Route,Switch } from 'react-router-dom';
import Sales from './components/Sales';
// import InventoryManagementSystem from './components/InventoryManagementSystem';
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute';
import ManageCustomer from './components/ManageCustomer';
import ManageItems from './components/ManageItems';
import SalesReport from './components/SalesReport';
import ManageUsers from './components/ManageUsers';
import SalesByDisplay from './components/SalesByDisplay';
import Estimate from './components/Estimate';
import EstimateReport from './components/EstimateReport';
import EditCompanySetup from './components/EditCompanySetup';
import EditSales from './components/EditSales';
import EditEstimate from './components/EditEstimate';
// import StoreSetup from './components/StoreSetup';
// import CompanySetup from './components/CompanySetup';

const roleRedirectMap = {
  "1": "/sales-report",
  "2": "/sales",
  "3": "/sales-report",
};

function App() {

  const { user, loading } = useAuth();

  if (loading) {
    return <div className="pos-common-main">
      <div style={{display: "flex", justifyContent: "center", margin: "5%"}}>
        <img 
          src='/images/loader.gif'
          style={{width: "100%", maxWidth: "441px"}}
        />
      </div>
      </div>;
  }

  return (
    <div className="App">
      <Router>
        {/* <AuthProvider> */}
        <Header />
        <Routes>
          {/* <Route path="/" element={<Navigate to="/user" />} />
          <Route path="/user" element={<Login />} /> */}
          {/* <Route path={"/user"}
            element={
              // user ? (
              //   <Navigate to={roleRedirectMap[user.role]}
              //   replace
              //   />
              // ) : (
              <Login />
            // )
            }
          /> */}

          <Route path={"/user"}
            element={
              user ? (
                <Navigate to={roleRedirectMap[user.role]} replace />
              ) : (
              <Login />
            )
            }
          />
          <Route path={"/"}
            element={
              user ? (<Navigate to={roleRedirectMap[user.role]} replace />) : (
            <Navigate to="/user" />
          )
          }
          />
          {/* <Route path={"/"}
            element={
              // user ? (<Navigate to={roleRedirectMap[user.role]} />) : (
            <Navigate to="/user" />
          // )
          }
          /> */}
          {/* <Route path="/productentry" element={
            <ProtectedRoute roles={["1", "2"]}>
              <ProductScan />
            </ProtectedRoute>
          } /> */}
          <Route path="/sales" element={
            <ProtectedRoute roles={["1", "2", "3"]}>
              <Sales />
            </ProtectedRoute>
          } />
          <Route path="/sales-by-display" element={
            <ProtectedRoute roles={["1", "2", "3"]}>
              <SalesByDisplay />
            </ProtectedRoute>
          } />
          <Route path="/estimate" element={
            <ProtectedRoute roles={["1", "2", "3"]}>
              <Estimate />
            </ProtectedRoute>
          } />
          {/* <Route path="/inventory-management" element={
            <ProtectedRoute roles={["1"]}>
              <InventoryManagementSystem />
            </ProtectedRoute>
          } /> */}
          <Route path="/manage-items" element={
            <ProtectedRoute roles={["1", "3"]}>
              <ManageItems />
            </ProtectedRoute>
          } />
          <Route path="/manage-customers" element={
            <ProtectedRoute roles={["1", "3"]}>
              <ManageCustomer />
            </ProtectedRoute>
          } />
          <Route path="/manage-users" element={
            <ProtectedRoute roles={["1", "3"]}>
              <ManageUsers />
            </ProtectedRoute>
          } />
          <Route path="/sales-report" element={
            <ProtectedRoute roles={["1", "3"]}>
              <SalesReport />
            </ProtectedRoute>
          } />
          <Route path="/estimate-report" element={
            <ProtectedRoute roles={["3"]}>
              <EstimateReport />
            </ProtectedRoute>
          } />
          <Route path="/edit-estimate/:id" element={
            <ProtectedRoute roles={["3"]}>
              <EditEstimate />
            </ProtectedRoute>
          } />
          <Route path="/company-setup/edit" element={
            <ProtectedRoute roles={["1", "3"]}>
              <EditCompanySetup />
            </ProtectedRoute>
          } />
          <Route path="/edit-sales/:id" element={
            <ProtectedRoute roles={["1", "3"]}>
              <EditSales />
            </ProtectedRoute>
          } />
          {/* <Route path="/store-setup" element={<StoreSetup />} />
          <Route path="/company-setup" element={<CompanySetup />} /> */}
        </Routes>
        {/* </AuthProvider> */}
      </Router>
    </div>
  );
}

export default App;
